import Angular from "angular";
import Template from "./vehicle-item.html";

export default Angular.module('vehicle-item', [])
    .component('vehicleItem', {
        template: Template,
        bindings: {
            vehicle: '<',
            iconRight: '@'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/vehicle-item/vehicle-item.js